<sm-spinner [loading]="loading$"></sm-spinner>
<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" [title]="'paa.variants.task' | translate: { taskName: task?.taskName }"> </sm-page-header>
  <div class="flex flex-row gap-5">
    <!-- Form -->
    <div class="content w-3/4">
      <sm-form-builder [formObject]="formObject"></sm-form-builder>
    </div>
    <!-- Meta Blocks -->
    <div class="flex flex-col gap-2 w-1/4">
      <sm-status [status]="status" [extra]="task?.paa?.etapeProcess || ''"></sm-status>
      <div class="content h-fit flex flex-col gap-4" *ngFor="let blocks of controlBlocks">
        <sm-block-builder [blocks]="blocks"></sm-block-builder>
      </div>
    </div>
  </div>
</div>
<sm-dialog #dialog [dialog]="paaDialogObject"></sm-dialog>
